var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34467 1.876C7.4036 1.56047 7.67902 1.33174 8 1.33174C8.32098 1.33174 8.5964 1.56047 8.65533 1.876L9.356 5.58133C9.45784 6.12046 9.87954 6.54216 10.4187 6.644L14.124 7.34467C14.4395 7.4036 14.6683 7.67902 14.6683 8C14.6683 8.32098 14.4395 8.5964 14.124 8.65533L10.4187 9.356C9.87954 9.45784 9.45784 9.87954 9.356 10.4187L8.65533 14.124C8.5964 14.4395 8.32098 14.6683 8 14.6683C7.67902 14.6683 7.4036 14.4395 7.34467 14.124L6.644 10.4187C6.54216 9.87954 6.12046 9.45784 5.58133 9.356L1.876 8.65533C1.56047 8.5964 1.33174 8.32098 1.33174 8C1.33174 7.67902 1.56047 7.4036 1.876 7.34467L5.58133 6.644C6.12046 6.54216 6.54216 6.12046 6.644 5.58133",
    stroke: "#171717",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.33333V4",
    stroke: "#171717",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 2.66667H12",
    stroke: "#171717",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 13.3333C1.33333 14.0692 1.93078 14.6667 2.66667 14.6667C3.40255 14.6667 4 14.0692 4 13.3333C4 12.5974 3.40255 12 2.66667 12C1.93078 12 1.33333 12.5974 1.33333 13.3333",
    stroke: "#171717",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarted);
export default __webpack_public_path__ + "static/media/started.e6ea9a54928371d28259d5e265927f8d.svg";
export { ForwardRef as ReactComponent };